import { $ as e, F as t, R as n, U as r, V as i, f as a, h as o, k as s, nt as c, ot as l, rt as u, t as d, v as f, w as p } from "./_plugin-vue_export-helper-CTQVpqU-.js";
//#region src/webcomponents/common/ButtonTooltip.ce.vue?vue&type=script&setup=true&lang.ts
var m = { class: "tooltip-container" }, h = ["id"], g = ["aria-labelledby", "aria-disabled"], _ = /*#__PURE__*/ d(/* @__PURE__ */ p({
	inheritAttrs: !1,
	__name: "ButtonTooltip.ce",
	props: {
		disabled: {
			type: Boolean,
			default: !1
		},
		label: { type: String },
		tooltipPosition: {
			default: "top",
			type: String
		}
	},
	emits: ["click"],
	setup(d, { expose: p, emit: _ }) {
		let v = e(!0), y = i(), b = r("button"), x = _;
		function S(e) {
			v.value = e;
		}
		function C() {
			d.disabled || x("click");
		}
		return p({ button: b }), (e, r) => (t(), f("div", m, [o("p", {
			id: c(y),
			class: u(["tooltip", {
				"sr-only": v.value || d.disabled,
				[`${d.tooltipPosition}`]: !0
			}])
		}, l(d.label), 11, h), o("button", s({ ref: "button" }, e.$attrs, {
			"aria-labelledby": c(y),
			"aria-disabled": d.disabled,
			class: { disabled: d.disabled },
			onMouseenter: r[0] ||= (e) => S(!1),
			onMouseleave: r[1] ||= (e) => S(!0),
			onFocusin: r[2] ||= (e) => S(!1),
			onFocusout: r[3] ||= (e) => S(!0),
			onClick: a(C, ["stop"])
		}), [n(e.$slots, "default")], 16, g)]));
	}
}), [["styles", ["*{--pix-neutral-800:#253858}.sr-only{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}.tooltip-container{display:grid;position:relative}.tooltip-container .tooltip{background:var(--pix-neutral-800);color:#fff;z-index:400;--horizontal-shift:12px;--tooltip-gap:1px;--arrow-height:6px;--arrow-width:5px;border-radius:4px;margin:0;padding:5px 7px;position:absolute}.tooltip-container .tooltip:before{content:\"\";position:absolute}.tooltip-container .tooltip.top{bottom:calc(100% + var(--tooltip-gap) + var(--arrow-height));transform:translateX(calc(var(--horizontal-shift) * -1));left:50%}.tooltip-container .tooltip.top:before{top:100%;left:calc(var(--horizontal-shift) - var(--arrow-width));border-right:var(--arrow-width) solid transparent;border-left:var(--arrow-width) solid transparent;border-top:var(--arrow-height) solid var(--pix-neutral-800)}.tooltip-container .tooltip.bottom{top:calc(100% + var(--tooltip-gap) + var(--arrow-height));transform:translateX(calc(var(--horizontal-shift) * -1));left:50%}.tooltip-container .tooltip.bottom:before{bottom:100%;left:calc(var(--horizontal-shift) - var(--arrow-width));border-right:var(--arrow-width) solid transparent;border-left:var(--arrow-width) solid transparent;border-bottom:var(--arrow-height) solid var(--pix-neutral-800)}.tooltip-container .tooltip.left{right:calc(100% + var(--tooltip-gap) + var(--arrow-height));top:50%;transform:translateY(-50%)}.tooltip-container .tooltip.left:before{border-top:var(--arrow-width) solid transparent;border-bottom:var(--arrow-width) solid transparent;border-left:var(--arrow-height) solid var(--pix-neutral-800);top:50%;left:100%;transform:translateY(-50%)}.tooltip-container .tooltip.right{left:calc(100% + var(--tooltip-gap) + var(--arrow-height));top:50%;transform:translateY(-50%)}.tooltip-container .tooltip.right:before{border-top:var(--arrow-width) solid transparent;border-bottom:var(--arrow-width) solid transparent;border-right:var(--arrow-height) solid var(--pix-neutral-800);top:50%;right:100%;transform:translateY(-50%)}.tooltip-container button:hover{cursor:pointer}.tooltip-container button.disabled{color:#797e89;cursor:not-allowed;background:0 0;border-color:#0000}"]]]);
//#endregion
export { _ as t };
